import React from 'react';

// Services & Helpers
import InstructorService from 'services/InstructorService';

// Components
import Loader from 'components/common/Loader';
import BookingsTable from 'components/bookings/BookingsTable';

//-------------------------------------------------------------------------------------------------------------------

class BookingsSection extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoadingYears: true,
            isLoadingBookings: true,
            bookings: null,
            years: null,
            year: null,
            requestID: 0
        };
    }

    componentDidMount() {
        if (this.props.type == 'past') {
            this.loadYears();
        } else {
            this.loadBookings(null);
        }
    }

    async loadYears() {
        const years = await InstructorService.listBookingYears(this.props.instructorID);
        this.setState({
            isLoadingYears: false,
            years: years
        });
        if (this.state.year) {
            this.loadBookings(this.state.year);
        } else if (years.length > 0) {
            this.loadBookings(years[0]);
        } else {
            this.setState({
                isLoadingBookings: false,
                bookings: []
            });
        }
    }

    async loadBookings(year) {
        this.setState({
            isLoadingYears: false,
            year: year,
            orderBy: 'DateDesc'
        });
        const bookings = await InstructorService.listBookings(this.props.instructorID, this.props.type, year);
        this.setState({
            isLoadingBookings: false,
            bookings,
            requestID: this.state.requestID - 1
        });
        if (this.props.onLoad) {
            this.props.onLoad(bookings);
        }
    }

    render() {
        const {
            bookings,
            years,
            year,
            isLoadingBookings,
            isLoadingYears,
            requestID
        } = this.state;
        const {
            title,
            emptyText,
            type,
            isEditMode,
            onSelect,
            canAdd,
            instructorID
        } = this.props;

        if (isLoadingBookings || isLoadingYears || !bookings) {
            return (<Loader />);
        }

        return (<>
            <h2>
                {title}

                {isEditMode && canAdd &&
                    <button onClick={e => onSelect({ status: 'Active', instructorID: instructorID }, () => {
                        if (this.props.type == 'past') {
                            this.loadYears();
                        } else {
                            this.loadBookings(null);
                        }
                    })} className="btn btn-sm">
                        <span className="fa-solid fa-plus"></span>{' '}
                        Add
                    </button>
                }

                {type == 'past' && years && years.length > 0 &&
                    <select
                        className="form-control"
                        value={year || ''}
                        onChange={e => this.loadBookings(parseInt(e.target.value))}
                    >
                        {years.map(year =>
                            <option key={year} value={year}>{year}</option>
                        )}
                    </select>
                }
            </h2>

            {bookings.length > 0 ?
                <BookingsTable
                    requestID={requestID}
                    mode="bookings" 
                    instructorID={instructorID}
                    isEditMode={isEditMode}
                    bookings={bookings}
                    isScrolling
                    onClick={booking => {
                        onSelect(booking, () => {
                            if (this.props.type == 'past') {
                                this.loadYears();
                            } else {
                                this.loadBookings(null);
                            }
                        });
                    }}
                /> :
                <div className="empty-text">
                    {emptyText}
                </div>
            }
        </>);
    }
}

export default BookingsSection;